import * as React from 'react';
import { Button, Col, Row } from 'antd';
import autobind from 'autobind-decorator';

import { AllotmentDataService } from 'src/app/products/allotment/form/allotment-form.data';
import { ProductAllotmentController } from 'src/app/products/products/parts/product-allotment.controller';
import { SupplierEditorController } from 'src/app/products/suppliers/parts/supplier-editor.controller';
import { TabLanguageController } from 'src/core/ui/language/tab-language.controller';
import { BooleanView } from 'src/core/ui/boolean.view';
import { RichTextView } from 'src/core/ui/richtextview/text.view.rich';
import { observer } from 'mobx-react';

interface ContractGeneralViewProps extends ComponentViewProps<ContractItem> {
	mode: ControlMode;
	supplierType?: number;
	supplierChange: (newVal: SupplierSummary) => void;
	onItemDoubleClicked?: (item: AllotmentItem) => any;
	updateAllotmentToContract?: (allotment: AllotmentItem) => void
	removeAllotmentToContract?: () => void
	editAllotment?: () => void
	contextService: any;
	onValidateGeneralInfo: (contract: ContractItem) => void;
	allotment: AllotmentItem,
	loadAllotmentsBysupplier?: (supplier: SupplierSummary) => Promise<AllotmentItem>;
}
interface State {
	supplierId?: number,
	disablePlusButton?:boolean
}
@observer
export class ContractGeneralView extends React.Component<ContractGeneralViewProps, State> {
	constructor(props) {
		super(props);
		this.state = {
			supplierId: this.props.model.supplierId,
		};
	}
	
	componentWillReceiveProps(nextProps: Readonly<ContractGeneralViewProps>, nextContext: any) {
	}
	@autobind
	private acceptOption(ev?: React.MouseEvent<HTMLButtonElement>) {
		ev.preventDefault();
		this.props.onItemDoubleClicked(null);
	}

	@autobind
	private editOption(ev?: React.MouseEvent<HTMLButtonElement>) {
		ev.preventDefault();
		this.props.editAllotment()
	}
	@autobind
	isDisablePlusButton() {
		if (this.props.mode == 'display')
			return true;
		else if (this.props.model.allotmentId != null)
			return true;
		else if (this.props.model.allotmentId == null && this.props.allotment && this.props.allotment.id > 0)
			return true;
		else if(this.state.disablePlusButton != null)
			return this.state.disablePlusButton;
		else
			return false
	}

	render() {
		const model = this.props.model;
		const displayNames = (model as any).dynamicProperties['displayName'];
		const array: TabLanguageModel[] = [{ title: 'Title', dynamicProperties: displayNames, required: true }];
		const { allotment } = this.props;
		const disablePlus = this.isDisablePlusButton(); 
		return (
			<Row gutter={16}>
				<Col xs={24} xl={12}>
					<Row gutter={16}>
						<Col xs={24}>
							<TabLanguageController
								model={this.props.model}
								dynamicProperties={array}
								mode={this.props.mode}
								setBusy={this.props.setBusy}
								isRichTextBox={false}
								onChanged={() => {
									this.props.onValidateGeneralInfo(this.props.model);
								}}
							/>
						</Col>
						<Col xs={24}>
							<RichTextView
								containerClassName="wysiwyg-editor-wrap-content"
								label="Cancellation Policy"
								value={this.props.model.dynamicProperties.cancelPolicy}
								onChanged={(html) => { this.props.model.dynamicProperties.cancelPolicy = html }}
								mode={this.props.mode}
							/>
						</Col>
					</Row>
				</Col>
				<Col xs={24} xl={12}>
					<Row gutter={16}>
						<Col xs={24}>
							<SupplierEditorController
								label='Supplier'
								required
								onGetErrorMessage={() => model.validate(false, 'supplierId')}
								supplierType={this.props.supplierType}
								mode={this.props.mode}
								onChange={(value: SupplierSummary) => {
									if (value != null)
										this.props.loadAllotmentsBysupplier(value).then(allotment => {
											model.allotmentId = allotment ? allotment.id : null;
											this.setState({
												supplierId: model.supplierId,
											});
										});
									model.supplierId = value ? value.id : null;
									model.supplierTitle = value ? value.title : null;
									this.props.onValidateGeneralInfo(model);

								}}
								value={model.supplierId}
								afterLoad={(res) => {
									if (res != null) {
										this.props.loadAllotmentsBysupplier(res).then(allotment => {
											model.allotmentId = allotment ? allotment.id : null;
											this.setState({
												supplierId: res.id,
											});
										});
									}
								}}
								setBusy={this.props.setBusy}
							/>
						</Col>
						{this.state.supplierId && <Col xs={24}>
							<ProductAllotmentController
								placeholder={allotment != null && allotment.id<0 ? allotment.name : "Select"}
								addAllotment={allotment != null && allotment.id < 0 ? allotment:null}
								productId={this.props.model.productId != null && this.props.model.tourItineraryId == null ? this.props.model.productId : this.props.model.tourItineraryId != null && this.props.model.productId == null ? this.props.model.tourItineraryId : undefined}
								supplierId={this.state.supplierId}
								mode={this.props.mode}
								afterLoad={(selected, options) => {
									if (options && options.length > 0)
										this.setState({ disablePlusButton: true })
									else
										this.setState({ disablePlusButton: false })

								}}
								onChanged={(value) => {
									if (value != null)
										this.props.updateAllotmentToContract(value);
									else if (value == null )
										this.props.removeAllotmentToContract();
								}
								}
								value={allotment ? allotment.id : this.props.model.allotmentId}
								{...this.props}>
								<Button.Group>
									<Button
										type="primary"
										style={{ minWidth: 'auto', width: '40px' }}
										onClick={this.acceptOption}
										disabled={disablePlus}
										icon={"plus"}
									/>
									<Button
										type="primary"
										style={{ minWidth: 'auto', width: '40px' }}
										icon={'edit'}
										onClick={this.editOption}
										disabled={this.props.mode == 'display' || this.props.model.allotmentId == null}
									/>
								</Button.Group>
							</ProductAllotmentController>
						</Col>}
						<Col xs={24} lg={12}>
							<BooleanView value={model.dynamicProperties.isCommissionable} label='Commissionable'
								onChanged={newVal => model.dynamicProperties.isCommissionable = newVal} mode={this.props.mode} />
						</Col>
						<Col xs={24} lg={12}>
							<BooleanView value={model.dynamicProperties.isReducible} label='Reducible'
								onChanged={newVal => model.dynamicProperties.isReducible = newVal} mode={this.props.mode} />
						</Col>
						<Col xs={24} lg={12}>
							<BooleanView value={model.dynamicProperties.requiresConfirmation} label='Requires confirmation'
								onChanged={newVal => model.dynamicProperties.requiresConfirmation = newVal} mode={this.props.mode} />
						</Col>
						<Col xs={24} lg={12}>
							<BooleanView value={model.isPublished} label='Published'
								onChanged={newVal => model.isPublished = newVal} mode={this.props.mode} />
						</Col>
					</Row>
				</Col>
			</Row>
		)
	}
}



// WEBPACK FOOTER //
// ./src/app/products/contract/form/parts/contract-general.view.tsx